<template>
    <div>
        <div v-if="fetchingFile">
            <v-skeleton-loader type="article@2"></v-skeleton-loader>
            <v-skeleton-loader type="paragraph" class="ml-4"></v-skeleton-loader>
        </div>
        <div v-else class="markdown-body" style="overflow-x: auto">
            <viewer @load="loaded" ref="toastuiEditor" :options="defaultOptions" :initialValue="editorText" height="500px" />
        </div>
    </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import 'github-markdown-css/github-markdown.css'
import { Viewer } from '@toast-ui/vue-editor'
import { toastEditor } from '@/mixins/toastEditor'

export default {
    name: 'MarkdownViewer',
    mixins: [toastEditor],
    components: {
        Viewer
    },
    watch: {
        editorText(nextVal) {
            this.$refs.toastuiEditor.invoke('setMarkdown', nextVal)
        }
    }
}
</script>

<style>
.markdown-body {
    font-family: inherit;
}

.markdown-body .toastui-editor-contents {
    color: #24292f;
    font-family: inherit;
    font-size: 16px;
    line-height: 1.5;
}

.markdown-body .toastui-editor-contents *:not(table) {
    line-height: inherit;
}

.markdown-body .toastui-editor-contents h1 {
    font-size: 32px;
    line-height: 1.25;
}

.markdown-body .toastui-editor-contents h2 {
    font-size: 24px;
    line-height: 1.25;
}

.markdown-body .toastui-editor-contents h3 {
    font-size: 20px;
    line-height: 1.25;
}

.markdown-body .toastui-editor-contents h4 {
    font-size: 16px;
    line-height: 1.25;
}

.markdown-body .toastui-editor-contents h5 {
    font-size: 14px;
    line-height: 1.25;
}

.markdown-body .toastui-editor-contents h6 {
    color: #57606a;
    font-size: 12px;
    line-height: 1.25;
}
</style>
